import { render, staticRenderFns } from "./BOIReportList.vue?vue&type=template&id=0286eb52&scoped=true&"
import script from "./BOIReportList.vue?vue&type=script&lang=ts&"
export * from "./BOIReportList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0286eb52",
  null
  
)

export default component.exports